/**
 * API Client.
 *
 * Provides a pre-configured Axios instance for communicating with the
 * TradeRoute backend API. All requests go through this client so that
 * base URL, headers, and interceptors are managed in one place.
 *
 * In development, Vite's proxy forwards /api requests to the backend,
 * so the base URL is just the current origin.
 */

import axios from "axios";

export const apiClient = axios.create({
  baseURL: "",
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * Request interceptor — attaches the JWT access token (when available)
 * to every outgoing request's Authorization header.
 */
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/**
 * Response interceptor — handles 401 Unauthorized responses globally
 * by clearing stored credentials and redirecting to the login page.
 */
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("access_token");
      // Redirect to login if we're not already there.
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);
